module.exports = __webpack_public_path__ + "media/images/resource/1692587287350-9e131e2dc58f8b8eb83da1e3ac28a7da.jpeg";